import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'
import FeatureList from 'front/components/FeatureList/FeatureList.js'
import PersonList from 'front/components/PersonList/PersonList.js'

import './About.css'
import template from './About.jinja'


var About = BaseView.extend({
    el: '.About',
    events: {
       'click .About-button': 'onOrderProjectClick'
    },
    initialize () {
        this.views = {}

        this.featureList = this.views.featureList = new FeatureList()
        this.personList = this.views.personList = new PersonList();
    },
    onOrderProjectClick() {
        app.views.applicationPopup.activate();
    }
})

export default About


// WEBPACK FOOTER //
// ./assets/app/front/components/About/About.js